import script from "./Whole.vue?vue&type=script&lang=ts"
export * from "./Whole.vue?vue&type=script&lang=ts"

import "./Whole.vue?vue&type=style&index=0&id=1954f8b4&lang=css"

export default script